export function DateDivider({ label }: { label: string }) {
  return (
    <div className="py-3 flex items-center justify-center select-none">
      <div className="flex items-center gap-3 w-full max-w-[420px]">
        <div className="h-px flex-1 bg-site-text/10" />
        <div className="px-3 py-1 rounded-full border border-site-border bg-site-bg/40 text-[11px] text-site-text/80">{label}</div>
        <div className="h-px flex-1 bg-site-text/10" />
      </div>
    </div>
  );
}

export function MonoWallpaperIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className || 'w-5 h-5'}
      aria-hidden="true"
    >
      <rect x="3.5" y="5" width="17" height="14" rx="2.2" />
      <path d="M7.5 15l3-3 2.5 2.5 2-2 3 2.5" />
      <circle cx="9" cy="9.5" r="1.1" />
    </svg>
  );
}

export function MonoTrashIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className || 'w-5 h-5'}
      aria-hidden="true"
    >
      <path d="M4 7h16" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
      <path d="M6 7l1 14h10l1-14" />
      <path d="M9 7V4h6v3" />
    </svg>
  );
}
